import { AppNS } from 'app';
import { isAdmin } from 'app/helpers/userRoles';
import { Location } from 'react-router-dom';

const getPathParts = (path: string): string[] => {
  return path.split('/');
};

export const agencyProfileResolverGuards = (
  data: AppNS.Company,
  location: Location<any>,
  currentUser: AppNS.User
): string => {
  const isUserAdmin = isAdmin(currentUser);
  if (isUserAdmin) {
    return '';
  }

  const canUserViewResult = canUserViewProfile(data, currentUser);
  if (canUserViewResult !== '') {
    return canUserViewResult;
  }

  return '';
};

function canUserViewProfile(data: AppNS.Company, currentUser: AppNS.User): string {
  if (!data || !currentUser) {
    return '/agency';
  }

  if (currentUser.id === data.ownerId) {
    return '';
  }

  const result = currentUser.employments?.find((employment) => {
    return employment.companyId === data.id;
  });

  return result ? '' : '/agency';
}

export function canUserAccessProfile(companyId: string, currentUser: AppNS.User): boolean {
  const isUserAdmin = isAdmin(currentUser);

  if (isUserAdmin) {
    return true;
  }

  if (currentUser.id === companyId) {
    return true;
  }

  const result = currentUser.employments?.find((employment) => {
    return employment.companyId === companyId;
  });

  return !!result;
}
